/* src/app/app.component.css */
@media (min-width: 768px) {
  .sidebar-nav .navbar .navbar-collapse {
    padding: 0;
    max-height: none;
  }
  .sidebar-nav .navbar ul {
    float: none;
    display: block;
  }
  .sidebar-nav .navbar li {
    float: none;
    display: block;
  }
  .sidebar-nav .navbar li a {
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
.clear {
  clear: both;
}
html,
body {
  height: 100%;
  margin: 0;
  overflow-x: hidden;
}
@keyframes pageEnter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.page-enter {
  animation: pageEnter 200ms ease both;
}
body {
  overflow-x: hidden;
  background-color: var(--bg-page);
}
.action-button-container {
  float: right;
  display: block;
  padding: 5px 5px 5px 0px;
  padding-right: 0px;
  text-align: right;
}
.main {
  margin-left: 260px;
  margin-top: 82px;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 24px 20px 40px 20px;
  display: block;
  min-height: calc(100vh - 82px - 8px);
  z-index: 0;
  background-color: var(--bg-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}
@media (max-width: 1199.98px) {
  .main {
    margin-left: 8px;
  }
}
.main-control {
  margin-top: 82px;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 24px 20px 40px 20px;
  display: block;
  min-height: calc(100vh - 82px - 8px);
  z-index: 0;
  background-color: var(--bg-surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}
@media (max-width: 767.98px) {
  .main .d-flex.justify-content-between,
  .main-control .d-flex.justify-content-between {
    flex-wrap: wrap;
    row-gap: 8px;
  }
}
.activation-panel {
  width: 100%;
  max-width: 400px;
  margin: var(--space-6) auto;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  text-align: center;
}
.activation-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-5) var(--space-6);
  background: var(--navy-600);
}
.activation-brand img {
  height: 34px;
  width: auto;
}
.activation-brand-word {
  color: var(--fg-on-navy);
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
}
.activation-body {
  padding: var(--space-6);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
}
.activation-user {
  margin: 0;
  font-weight: var(--weight-semibold);
  color: var(--fg-1);
}
.activation-message {
  margin: 0;
  color: var(--fg-2);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}
/*# sourceMappingURL=app.component.css.map */
